﻿$.fn.dxCtrlSuiviTraitementEmailServeur = function custom_dxCtrlSuiviTraitementEmailServeur(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsuivitraitementemailserveur dx-ctrl");
        this.createInstance(new cdxCtrlSuiviTraitementEmailServeur(this, option));
    }
    return this;
}

window.cdxCtrlSuiviTraitementEmailServeur = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    //$(document).on('sendedEmailEvent', function (e, eventInfo) {
    //    mLoadData()
    //});

    var $DivReceive = null
    var $DivSend = null
    var lstCtrlEmailReceive = []
    var lstCtrlEmailSmsSend = []
    function mConstruit() {
        //container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty()
        container.css("padding", "0 5px")
        $DivReceive = $("<div style='display:none;'/>").appendTo(container)
        $("<div><b>Réception en cours...</b></div>").appendTo($DivReceive)
        $DivSend = $("<div style='display:none;padding-top:10px;'/>").appendTo(container)
        $("<div><b>Envoi en cours...</b></div>").appendTo($DivSend)
        mLoadData()
        //container.css("height", "")
    }

    var timeOutLoadData = null
    function mLoadData() {
        if (container.closest("body").length==0) return
        window.clearTimeout(timeOutLoadData)
        option.bddCtrl.mAjaxCall({ command: "getdataemailsmssuiviserveur" }, function (data) {
            var lstCptEmailReceive = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCompteEmail) {
                return parseInt(dataCompteEmail.nb_email_total_to_load) > 100
            })
            if (typeof data.lst_com_email_envoi_mailing == 'undefined') data.lst_com_email_envoi_mailing = []
            if (typeof data.lst_com_sms_envoi_mailing == 'undefined') data.lst_com_sms_envoi_mailing = []
            //if (option.email_recu) mRempliReceive(lstCptEmailReceive)
            if (option.email_envoi) mRempliSend(data.lst_com_email_envoi_mailing, "com_email_envoi")
            if (option.sms_envoi) mRempliSend(data.lst_com_sms_envoi_mailing, "com_sms_envoi")

            timeOutLoadData = window.setTimeout(function () {
                mLoadData()
            }, ((lstCptEmailReceive.length > 0 || data.lst_com_email_envoi_mailing.length > 0 || data.lst_com_sms_envoi_mailing.length > 0) ? 7000 : 30000))
        })
    }

    //function mRempliReceive(newLstDataCompteEmail) {
    //    //on rajoute ou met a jour les éléments pour la réception
    //    newLstDataCompteEmail.forEach(function (dataCompteEmail) {
    //        var trouver = false
    //        lstCtrlEmailReceive.forEach(function (ctrlSuivi) {
    //            if (!trouver && ctrlSuivi.option("data").id_compte_email == dataCompteEmail.id_compte_email) {
    //                trouver = true
    //                ctrlSuivi.mUpdataData(dataCompteEmail)
    //            }
    //        })
    //        if (!trouver) {
    //            var ctrl = $("<div style='font-size:80%;'/>").appendTo($DivReceive).dxCtrlSuiviTraitementEmailServeurReception({
    //                bddCtrl: option.bddCtrl,
    //                data: dataCompteEmail
    //            }).dxCtrlSuiviTraitementEmailServeurReception("instance")
    //            lstCtrlEmailReceive.push(ctrl)
    //        }
    //    })

    //    var lstCtrlToDel = []
    //    lstCtrlEmailReceive.forEach(function (ctrlSuivi) {
    //        trouver = false
    //        newLstDataCompteEmail.forEach(function (dataCompteEmail) {
    //            if (!trouver && ctrlSuivi.option("data").id_compte_email == dataCompteEmail.id_compte_email) {
    //                trouver = true
    //            }
    //        })
    //        if (!trouver) lstCtrlToDel.push(ctrlSuivi)
    //    })

    //    lstCtrlToDel.forEach(function (ctrl) {
    //        ctrl.element().slideUp(200, function () { ctrl.element().remove })
    //        lstCtrlEmailReceive.splice(lstCtrlEmailReceive.indexOf(ctrl), 1)
    //    })

    //    if (lstCtrlEmailReceive.length > 0) { $DivReceive.show() }
    //    else { $DivReceive.hide() }
    //}

    function mRempliSend(newLstDataComEmailSmsEnvoi, nomTable) {
        //on rajoute ou met a jour les éléments pour la réception
        newLstDataComEmailSmsEnvoi.forEach(function (dataComEmailSmsEnvoi) {
            var trouver = false
            lstCtrlEmailSmsSend.forEach(function (ctrlSuivi) {
                if (!trouver && ctrlSuivi.option("data")["id_" + nomTable] == dataComEmailSmsEnvoi["id_" + nomTable]) {
                    trouver = true
                    ctrlSuivi.mUpdataData(dataComEmailSmsEnvoi)
                }
            })
            if (!trouver) {
                var ctrl = $("<div style='font-size:80%;'/>").appendTo($DivSend).dxCtrlSuiviTraitementEmailServeurEnvoi({
                    bddCtrl: option.bddCtrl,
                    data: dataComEmailSmsEnvoi
                }).dxCtrlSuiviTraitementEmailServeurEnvoi("instance")
                lstCtrlEmailSmsSend.push(ctrl)
            }
        })

        var lstCtrlToDel = []
        lstCtrlEmailSmsSend.forEach(function (ctrlSuivi) {
            trouver = false
            newLstDataComEmailSmsEnvoi.forEach(function (dataComEmailSmsEnvoi) {
                if (!trouver && ctrlSuivi.option("data")["id_" + nomTable] == dataComEmailSmsEnvoi["id_" + nomTable]) {
                    trouver = true
                }
            })
            if (!trouver) lstCtrlToDel.push(ctrlSuivi)
        })

        lstCtrlToDel.forEach(function (ctrl) {
            ctrl.element().slideUp(200, function () { ctrl.element().remove })
            lstCtrlEmailSmsSend.splice(lstCtrlEmailSmsSend.indexOf(ctrl), 1)
        })

        if (lstCtrlEmailSmsSend.length > 0) { $DivSend.show() }
        else { $DivSend.hide() }
    }

    this.element = function () { return container }

    mConstruit();
}